module.exports = "<div class=\"row\"\n  ng-form=\"railwaySelectForm\">\n  <my-select class=\"col s12 m6\"\n    ng-model=\"myArea\"\n    my-options=\"areaFieldsOptions.selectArea\"\n    my-data=\"areas\">\n  </my-select>\n\n  <my-input class=\"col s12 m6\"\n    ng-model=\"myRailway.number\"\n    my-options=\"railwayFieldsOptions.number\"\n    autocomplete=\"railways\">\n  </my-input>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/rails/railway/directives/inputs/mySelectRailway.html
// module id = 945
// module chunks = 0